/* eslint-disable */
import PropTypes from 'prop-types';
import ServicesContextPropTypes from '../../Contexts/Services/Services.props';
import ThemeStatePropTypes from '../../State/Store/Theme/Theme.props';

const OrderListPropTypes = {
  /**
   * The JSS classes to use
   */
  classes: ThemeStatePropTypes.classes.isRequired,

  /**
   * The filters
   */
  filters: PropTypes.object,

  /**
   * The orders
   */
  orders: PropTypes.array,

  /**
   * The orders error
   */
  ordersError: PropTypes.object,

  /**
   * The orders error
   */
  ordersLoading: PropTypes.bool,

  /**
   * The services to be used by the given entry
   */
  services: ServicesContextPropTypes.services.isRequired,

  /**
   * The JSS theme to use
   */
  theme: ThemeStatePropTypes.theme.isRequired,
};

export default OrderListPropTypes;
